import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lln_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token expired - clear
      if (localStorage.getItem("lln_token")) {
        localStorage.removeItem("lln_token");
        localStorage.removeItem("lln_user");
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtCLP = (n) =>
  n == null
    ? "—"
    : new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n);

export const fmtNumber = (n) =>
  n == null ? "—" : new Intl.NumberFormat("es-CL").format(n);

const CL_TZ = "America/Santiago";

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-CL", { timeZone: CL_TZ, year: "numeric", month: "short", day: "numeric" });
};

export const fmtDateTimeCL = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("es-CL", {
    timeZone: CL_TZ, day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

export const fmtDateShortCL = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("es-CL", {
    timeZone: CL_TZ, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
};

export const fmtTimeCL = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("es-CL", {
    timeZone: CL_TZ, hour: "2-digit", minute: "2-digit",
  });
};

export const resolveImg = (path, width = 1200) => {
  if (!path) return `https://images.unsplash.com/photo-1497366216548-37526070297c?w=${width}&q=70&auto=format&fit=crop`;
  if (path.startsWith("http")) {
    // Optimize unsplash URLs by overriding width and quality
    if (path.includes("images.unsplash.com")) {
      const url = new URL(path);
      url.searchParams.set("w", String(width));
      url.searchParams.set("q", "70");
      url.searchParams.set("auto", "format");
      return url.toString();
    }
    return path;
  }
  return `${API_BASE}/files/${path}`;
};
